import { MapPin } from "lucide-react";
import { fromISO, formatDayLong } from "../utils/date.js";

export default function DayHero({ date, leg, tripStart, totalDays }) {
  const d = fromISO(date);
  const dayNum = Math.floor((d - tripStart) / 86400000) + 1;

  return (
    <div
      className="relative px-5 pt-6 pb-5 overflow-hidden"
      style={{
        background: leg ? `linear-gradient(135deg, ${leg.colour} 0%, ${leg.colour}dd 100%)` : "#0f172a",
        color: "white",
      }}
    >
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence baseFrequency='0.9'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.4'/></svg>")`,
        }}
      />
      <div className="relative">
        <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.25em] font-semibold opacity-80">
          <span>Day {dayNum} of {totalDays}</span>
          {leg?.tentative && <span className="px-2 py-0.5 rounded-full bg-white/20 backdrop-blur">Tentative</span>}
        </div>
        <h1 className="mt-2 text-3xl font-semibold leading-tight" style={{ fontFamily: "'Fraunces', Georgia, serif", letterSpacing: "-0.02em" }}>
          {formatDayLong(d)}
        </h1>
        {leg && (
          <div className="mt-2 flex items-center gap-2 text-sm opacity-95">
            <MapPin size={14} />
            <span className="font-medium">{leg.emoji} {leg.city}, {leg.country}</span>
          </div>
        )}
      </div>
    </div>
  );
}
